export default "__VITE_ASSET__BBkQMu4K__"